<template>
  <div class="aigc-layout">
    <router-view />
    <van-popup
      v-model="menuVisible"
      position="left"
      :style="{ width: '82%', maxWidth: '320px', height: '100%' }"
      class="aigc-layout-menu-popup"
    >
      <AigcSidebar
        :active-route-name="$route.name"
        @nav="onMenuNav"
        @create="onMenuCreate"
      />
    </van-popup>
  </div>
</template>

<script>
import AigcSidebar from "./AigcSidebar.vue";
import {
  getAigcFrontUrl,
  getMobileRouteName,
  isMobileNavRoute,
} from "./aigcNavConfig";

export default {
  name: "AigcLayout",
  components: { AigcSidebar },
  data() {
    return {
      menuVisible: false,
    };
  },
  provide() {
    return {
      openAigcMenu: this.openAigcMenu,
    };
  },
  methods: {
    openAigcMenu() {
      this.menuVisible = true;
    },
    closeAigcMenu() {
      this.menuVisible = false;
    },
    onMenuCreate() {
      this.closeAigcMenu();
      if (this.$route.name !== "aigc_create") {
        this.$router.push({ name: "aigc_create" });
      }
    },
    onMenuNav(key) {
      this.closeAigcMenu();
      if (key === "aigc_create") {
        this.onMenuCreate();
        return;
      }
      if (isMobileNavRoute(key)) {
        const name = getMobileRouteName(key);
        if (name && this.$route.name !== name) {
          this.$router.push({ name });
        }
        return;
      }
      const url = getAigcFrontUrl(key);
      if (url) {
        window.location.href = url;
        return;
      }
      this.$toast("暂未开放");
    },
  },
};
</script>

<style scoped>
.aigc-layout {
  min-height: 100vh;
  min-height: 100dvh;
}
</style>

<style>
.aigc-layout-menu-popup.van-popup {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/aigc/AigcLayout.vue